// Enums
export enum DiscountType {
    PERCENTAGE = "PERCENTAGE",
    FIXED_AMOUNT = "FIXED_AMOUNT"
}

// Main Voucher Interface theo Backend Schema chính xác
export interface Voucher {
    id: number;
    code: string;
    name: string;                      // Backend sử dụng 'name', không phải 'title'
    description?: string;
    type: 'FREE' | 'PAID';            // Backend sử dụng 'type' 
    discountType: DiscountType;        
    discount: number;                  // Backend sử dụng 'discount', không phải 'discountValue'
    minOrder?: number;                 // Backend sử dụng 'minOrder', không phải 'minOrderValue'
    maxDiscount?: number;              // Backend sử dụng 'maxDiscount', không phải 'maxDiscountAmount'
    pointsCost?: number;               // Backend sử dụng 'pointsCost', không phải 'pointsRequired'
    quantity: number;                  // Backend sử dụng 'quantity', không phải 'usageLimit'
    usedCount: number;
    startDate: Date;
    endDate: Date;
    isActive: boolean;
    createdAt: Date;
    updatedAt: Date;
    
    // Frontend compatibility fields (để không phá vỡ UI hiện tại)
    title?: string;                    // Map từ name cho UI
    discountValue?: number;            // Map từ discount cho UI
    minOrderValue?: number;            // Map từ minOrder cho UI
    maxDiscountAmount?: number;        // Map từ maxDiscount cho UI
    pointsRequired?: number;           // Map từ pointsCost cho UI
    usageLimit?: number;               // Map từ quantity cho UI
    usagePerUser?: number;             // Không có trong backend schema hiện tại
}

// DTO cho tạo voucher mới - theo Backend Schema chính xác
export interface CreateVoucherDto {
    // Backend required fields
    code: string;                      // Bắt buộc
    name: string;                      // Bắt buộc - Backend sử dụng 'name'
    type: 'FREE' | 'PAID';            // Bắt buộc
    discount: number;                  // Bắt buộc - Backend sử dụng 'discount'
    quantity: number;                  // Bắt buộc - Backend sử dụng 'quantity'
    startDate: Date | string;          // Bắt buộc
    endDate: Date | string;            // Bắt buộc
    
    // Backend optional fields
    description?: string;              // Tùy chọn
    discountType?: DiscountType;       // Tùy chọn - default PERCENTAGE
    minOrder?: number;                 // Tùy chọn - Backend sử dụng 'minOrder'
    maxDiscount?: number;              // Tùy chọn - Backend sử dụng 'maxDiscount'
    pointsCost?: number;               // Tùy chọn - Backend sử dụng 'pointsCost'
    isActive?: boolean;                // Tùy chọn - default true
    
    // Frontend compatibility fields (để map từ UI)
    title?: string;                    // Map to name
    discountValue?: number;            // Map to discount
    minOrderValue?: number;            // Map to minOrder
    maxDiscountAmount?: number;        // Map to maxDiscount
    pointsRequired?: number;           // Map to pointsCost
    usageLimit?: number;               // Map to quantity
    usagePerUser?: number;             // Không có trong backend schema
}

// DTO cho cập nhật voucher
export interface UpdateVoucherDto {
    title?: string;
    description?: string;
    discountValue?: number;
    maxDiscountAmount?: number;
    usageLimit?: number;
    isActive?: boolean;
}

// User Voucher Interface
export interface UserVoucher {
    id: number;
    userId: number;
    voucherId: number;
    voucher: Voucher;
    isUsed: boolean;
    usedAt?: Date;
    orderId?: number;
    obtainedAt: Date;
}

// Validate Request/Response
export interface ValidateVoucherRequest {
    orderTotal: number;
}

export interface ValidateVoucherResponse {
    isValid: boolean;
    canUse: boolean;
    reason?: string;
    voucher?: Voucher;
}

// Calculate Request/Response
export interface CalculateVoucherRequest {
    orderTotal: number;
}

export interface CalculateVoucherResponse {
    originalAmount: number;
    discountType: DiscountType;
    discountPercent?: number;
    discountAmount: number;
    finalAmount: number;
    maxDiscountReached?: boolean;
    voucher: {
        code: string;
        title: string;
    };
}

// Exchange Response
export interface ExchangeVoucherResponse {
    userVoucher: UserVoucher;
    pointsDeducted: number;
    remainingPoints: number;
}

// Use Voucher Response
export interface UseVoucherResponse {
    userVoucher: {
        id: number;
        isUsed: boolean;
        usedAt: Date;
        orderId?: number;
    };
    discountAmount: number;
    message: string;
}

// API Response wrapper
export interface VoucherApiResponse<T> {
    statusCode: number;
    message: string;
    data: T;
    error?: string;
    details?: any;
}